import { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import { useAccounts } from '../lib/useAccounts';
import { allComms } from '../lib/salesData';

const CH = ['all', 'email', 'phone', 'text', 'portal'] as const;
const chLabel: Record<string, string> = { email: 'Email', phone: 'Call', text: 'Text', portal: 'Portal' };

export default function CommsLog() {
  const { demo } = useAuth();
  const { data, loading } = useAccounts(demo);
  const nav = useNavigate();
  const [ch, setCh] = useState<(typeof CH)[number]>('all');
  const [q, setQ] = useState('');

  const comms = useMemo(() => allComms(data?.accounts ?? []), [data]);
  const rows = useMemo(() => {
    let r = comms;
    if (ch !== 'all') r = r.filter((c) => c.channel === ch);
    if (q.trim()) { const t = q.toLowerCase(); r = r.filter((c) => c.clientName.toLowerCase().includes(t) || c.subject.toLowerCase().includes(t)); }
    return r;
  }, [comms, ch, q]);

  if (loading) return <div className="loading"><div className="spinner" /> Loading communication log…</div>;
  const shown = rows.slice(0, 400);

  return (
    <>
      <div className="page-head">
        <div><div className="page-title">Client Communication Log</div><div className="page-sub">Know who said what, when, and through which channel.</div></div>
        <span className="live-flag">{comms.length} logged</span>
      </div>
      <div className="toolbar">
        <input className="search" placeholder="Search client or subject…" value={q} onChange={(e) => setQ(e.target.value)} />
        <div className="seg">{CH.map((c) => <button key={c} className={ch === c ? 'on' : ''} onClick={() => setCh(c)}>{c === 'all' ? 'All' : chLabel[c]}</button>)}</div>
      </div>
      <div className="page-sub" style={{ marginBottom: 10 }}>{rows.length} entries{rows.length > 400 ? ' (showing 400)' : ''}</div>
      <div className="table-wrap"><table>
        <thead><tr><th>Channel</th><th>Client</th><th>Subject</th><th>Direction</th><th>When</th></tr></thead>
        <tbody>
          {shown.map((c) => (
            <tr key={c.id} onClick={() => nav(`/client?id=${encodeURIComponent(c.clientId)}`)}>
              <td><span className={`chan-badge ch-${c.channel}`}>{chLabel[c.channel]}</span></td>
              <td>{c.clientName}</td>
              <td style={{ color: 'var(--tx2)' }}>{c.subject}</td>
              <td><span className={`tag ${c.dir === 'in' ? 'st-new' : 'st-completed'}`}>{c.dir === 'in' ? 'Inbound' : 'Outbound'}</span></td>
              <td>{c.time}</td>
            </tr>
          ))}
          {rows.length === 0 && <tr><td colSpan={5}><div className="empty">No communications match.</div></td></tr>}
        </tbody>
      </table></div>
    </>
  );
}
